import { render, staticRenderFns } from "./CoinMarket.vue?vue&type=template&id=dbee8c32&scoped=true"
import script from "./CoinMarket.vue?vue&type=script&lang=js"
export * from "./CoinMarket.vue?vue&type=script&lang=js"
import style0 from "./CoinMarket.vue?vue&type=style&index=0&id=dbee8c32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbee8c32",
  null
  
)

export default component.exports